﻿<script setup>
    import { useDialogPluginComponent } from 'quasar'
    defineEmits([...useDialogPluginComponent.emits])
    const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

    const props = defineProps({
        title: String,
        message: String,
        input: String,
        icon: {
            type: String,
            default: 'info'
        },
        size: String
    });

    const text = ref('');

    function onOk() {
        onDialogOK(text.value);
    }

    if (props.input) {
        text.value = props.input;
    }
</script>

<template>
    <q-dialog ref="dialogRef" @hide="onDialogHide" :persistent="true">
        <window :title="title" :icon="icon" :size="size">
            <template #actions>
                <q-btn flat label="Cancel" color="dark" @click="onDialogCancel" />
                <q-btn flat label="Ok" color="primary" @click="onOk" :disabled="!text.length" />
            </template>
            {{message}}

            <q-input debounce="100"
                        dense
                        v-model="text"
                        type="textarea"
                        autofocus/>
        </window>
    </q-dialog>
</template>